/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
// Copyright (c) 2022 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';

function handlePercentageChange(value) {

    this.onPercentageChange(value);

}
const PercentageScreen = props =>
    <section className='percentage-debit-screen'>
        <span className='percentage-name'>
            <FormattedMessage id='PERCENTAGE_TO_DEBIT'/>
        </span>
        <span className='value-of-adjustment'>
            <FormattedNumberInput
                allowNegative={false}
                decimalPrecision={2}
                isValidInput={value => value < 100}
                onValueChange={props::handlePercentageChange}
                value={props.percentage}
            />
        </span>
        <div className='button-group'>
            <button
                className='primary'

                // disabled={isSubmitDisabled}

                onClick={props.onApplyClick}

            >
                <FormattedMessage id='APPLY'/>
            </button>
        </div>
    </section>;

PercentageScreen.displayName = 'PercentageScreen';
PercentageScreen.propTypes = {
    onApplyClick: PropTypes.func.isRequired,
    onPercentageChange: PropTypes.func.isRequired,
    percentage: PropTypes.number.isRequired
};

export default PercentageScreen;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-screen/percentage-screen.js